import {
  RowDataReducerState,
  RowDataReducerAction,
  RowData,
  GenericRowData,
} from "../../../../../types";

export const handlePOConfigurationGroupShippingInfoDefaultAddress = (
  propertyKey: string,
  propertySubKey: string | undefined,
  rowIndex: number | undefined,
  inputValue: boolean,
  selectedTabSectionKey: string,
  rowDataReducerState: RowDataReducerState,
  dispatch: React.Dispatch<RowDataReducerAction>,
): void => {
  if (!inputValue || rowIndex === undefined) return;

  const sectionData = rowDataReducerState.rowData[
    selectedTabSectionKey
  ] as RowData;
  const rows = (sectionData[propertyKey] as GenericRowData[]) || [];

  rows.forEach((_, index) => {
    // Only update other rows (not the one just set to true)
    if (index !== rowIndex) {
      dispatch({
        type: "UPDATE_FIELD",
        payload: {
          propertyKey,
          propertySubKey,
          rowIndex: index,
          newFieldValue: false,
          selectedTabSectionKey,
        },
      });
    }
  });
};
